var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.998047,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "url(#paint0_linear_842_6609)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.498 26L21.098 24.55L24.648 21H12.498V19H24.648L21.098 15.45L22.498 14L28.498 20L22.498 26Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_842_6609",
    x1: -0.227688,
    y1: 20.8391,
    x2: 41.15,
    y2: 20.8391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowInCircle);
export default __webpack_public_path__ + "static/media/arrow-in-circle.a79d597c4bb95540afe212b5772b447b.svg";
export { ForwardRef as ReactComponent };